import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PauseCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PauseCircleSVG;
